import { render, staticRenderFns } from "./EditTemplates.vue?vue&type=template&id=480b1eed"
import script from "./EditTemplates.vue?vue&type=script&lang=js"
export * from "./EditTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports